'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  updateLineItems();
};

var updateLineItems = function updateLineItems() {
  (0, _jquery2.default)('.add-properties').each(function () {
    var properties = {};
    (0, _jquery2.default)(this).find(_dom2.default.property).each(function () {
      var $current = (0, _jquery2.default)(this);

      if ($current.val() != "") {
        var propertyName = $current.attr('name').replace('properties[', '').replace(']', '');
        properties[propertyName] = $current.val();
      }
    });

    var key = (0, _jquery2.default)(this).data('key');
    var quantity = (0, _jquery2.default)(this).find(_dom2.default.qtyInput).val();
    quantity = parseInt(quantity);

    cart.updateItem(key, { quantity: quantity, properties: properties });
  });
};